import { performanceModel } from 'portfolio3/features/performance';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const finalPerfomanceYearsSelector = createSelector(
  performanceModel.selectors.learningYearFinalPerformanceSelector,
  (finalPerfomance) =>
    extractDatesFromNestedItems(finalPerfomance?.content, [
      {
        type: 'academicYearString',
        field: 'year',
      },
    ]),
);
